<script lang="ts">
    import { formatNumberShort } from "@/utils/formatNumberShort/formatNumberShort";
    import CN from "classnames";
    import { createEventDispatcher } from "svelte";

    import WishlistIcon from "@components/WishlistIcon/WishlistIcon.svelte";

    import { WishlistProductStatusEntity } from "../entities/WishlistProductStatusEntity";
    import { WishlistsStorefrontValuesBrandingEntity } from "../entities/WishlistsStorefrontValuesBrandingEntity";

    export let productInWishlistStatus: boolean | undefined;
    export let loading: boolean;
    export let button_accessibility_label: string;
    export let isCounterEnabled: boolean;
    export let wishlistCounterPosition: "left-top" | "right-top";
    export let wishlistProductStatus: WishlistProductStatusEntity | undefined;
    export let wishlistBrandingIconSettings: WishlistsStorefrontValuesBrandingEntity["wishlistIconSettings"];

    const dispatch = createEventDispatcher();

    const handleToggle = () => {
        dispatch("toggle");
    };
</script>

<button
    class={CN("gw-toggle-wishlist-product-card-button", {
        "gw-toggle-wishlist-product-card-button--loading": loading,
    })}
    data-in-wishlist={!!productInWishlistStatus}
    on:click={handleToggle}
    aria-label={button_accessibility_label}
>
    <WishlistIcon
        width={20}
        height={20}
        isFilled={productInWishlistStatus}
        iconSettings={wishlistBrandingIconSettings}
    />

    {#if isCounterEnabled && wishlistProductStatus && wishlistProductStatus.wishlistItemsCount !== 0}
        <div
            class="gw-toggle-wishlist-product-card-button__counter"
            class:gw-toggle-wishlist-product-card-button__counter--left-top={wishlistCounterPosition ===
                "left-top"}
            class:gw-toggle-wishlist-product-card-button__counter--right-top={wishlistCounterPosition ===
                "right-top"}
        >
            {formatNumberShort(wishlistProductStatus.wishlistItemsCount)}
        </div>
    {/if}
</button>

<style lang="postcss">
    .gw-toggle-wishlist-product-card-button {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 0;
        width: 32px;
        height: 32px;
        padding: 0;
        border-radius: 50%;
        margin: 0 0 0 auto;
        background: none;
        cursor: pointer;
        background: var(--gw-wl-wishlistIconSettings-backgroundColor);
        color: var(--gw-wl-wishlistIconSettings-heartColor);
        box-shadow: 0px 8px 16px -8px #3737371f;
    }

    .gw-toggle-wishlist-product-card-button__counter {
        position: absolute;
        background-color: var(--gw-wl-wishlistIconSettings-heartColor);
        color: var(--gw-wl-wishlistIconSettings-backgroundColor);
        font-size: 10px;
        padding: 1px 3px;
        text-align: center;
        min-width: 15px;
        box-sizing: border-box;
        border: 1px solid var(--gw-wl-wishlistIconSettings-backgroundColor);
        border-radius: 30px;

        &--left-top {
            top: 0;
            right: 50%;
            transform: translate(-10%, -20%);
        }

        &--right-top {
            top: 0;
            left: 50%;
            transform: translate(10%, -20%);
        }
    }

    .gw-toggle-wishlist-product-card-button__counter-skeleton {
        margin-left: 6px;
        width: 1.5em;
        height: 0.9em;
        background-color: var(--gw-theme__main-color-lighten-10);
        border-radius: 3px;
    }
</style>
